import React from "react";

export const TrainerFormHeader = ({ children }: React.PropsWithChildren): JSX.Element => {
  return <span className="text-left font-semibold col-span-3 text-black-100"> {children}</span>;
};
